module.exports = __webpack_public_path__ + "img/rent-relax.973a022a.svg";